import React, { Component } from "react";
import { connect } from "react-redux";

import { converDateIntoLocal } from "../../../../../../common/common-functions";
import _ from "lodash";
import { ProductTextLocalized } from "../../../../../../common/common-functions";

class ProductBaseItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    var { values, language } = this.props;

    let tabledate = "";
    tabledate = converDateIntoLocal(values.updatedon).format(
      "D MMM YYYY HH:mm A"
    );

    return (
      <>
        <tr className="bg-white border-b-2 border-gray-50 cursor-pointer hover-all">
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {ProductTextLocalized(
              values.productname_en,
              values.productname_ar,
              language
            )}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {_.startCase(values.createdby.username)}
          </td>

          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {tabledate}
          </td>
        </tr>
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var { session, user } = state;
  // console.log('customerlistingtabs',state.customerlistingtabs);
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    language: state.language,
  };
}
export default connect(mapStateToProps, {})(ProductBaseItems);
